import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "../blocks/copyright";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import SyncProblemIcon from '@mui/icons-material/SyncProblem';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ArticleIcon from '@mui/icons-material/Article';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import InventoryIcon from '@mui/icons-material/Inventory';
import {Link, useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import SummarizeIcon from "@mui/icons-material/Summarize";

const SECTIONS = [
    {type: 'biznes_reja',        labelKey: 'section_biznes_reja',        Icon: ArticleIcon},
    {type: 'kuzgi_qishki',       labelKey: 'section_kuzgi_qishki',       Icon: AcUnitIcon},
    {type: 'mehnat_muhofazasi',  labelKey: 'section_mehnat_muhofazasi',  Icon: HealthAndSafetyIcon},
    {type: 'yongin_xavfsizligi', labelKey: 'section_yongin_xavfsizligi', Icon: WhatshotIcon},
    {type: 'inventarizatsiya',   labelKey: 'section_inventarizatsiya',   Icon: InventoryIcon},
]

// Viloyatning shaxsiy bo'limi — o'zi yuboriladigan ma'lumotlar
function Personal() {
    const {t} = useTranslation()
    const navigate = useNavigate()

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/>
                <Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={() => navigate(-1)}>
                            {t('back')}
                        </Button>
                        <h2 className={'page-title'}>{t('personal_section')}</h2>
                        <div className="row">
                            <div className="col-lg-3">
                                <Link to={'/documents/'}>
                                    <div className="card">
                                        <div className="card-header"><FilePresentIcon className={'icon-card'}/></div>
                                        <div className="card-body"><h3 className={'text-center mb-0 text-uppercase'}>{t('required_documents')}</h3></div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-lg-3">
                                <Link to={'/problems/'}>
                                    <div className="card">
                                        <div className="card-header"><SyncProblemIcon className={'icon-card'}/></div>
                                        <div className="card-body"><h3 className={'text-center mb-0 text-uppercase'}>{t('problems')}</h3></div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-lg-3">
                                <Link to={'/workers/'}>
                                    <div className="card">
                                        <div className="card-header"><FolderSharedIcon className={'icon-card'}/></div>
                                        <div className="card-body"><h3 className={'text-center mb-0 text-uppercase'}>{t('workers')}</h3></div>
                                    </div>
                                </Link>
                            </div>
                            <div className="col-lg-3">
                                <Link to={'/reports/'}>
                                    <div className="card">
                                        <div className="card-header"><SummarizeIcon className={'icon-card'}/></div>
                                        <div className="card-body"><h3 className={'text-center mb-0 text-uppercase'}>{t('reports')}</h3></div>
                                    </div>
                                </Link>
                            </div>
                            {SECTIONS.map(({type, labelKey, Icon}) => (
                                <div className="col-lg-3" key={type}>
                                    <Link to={`/sections/${type}/`}>
                                        <div className="card">
                                            <div className="card-header"><Icon className={'icon-card'}/></div>
                                            <div className="card-body"><h3 className={'text-center mb-0 text-uppercase'}>{t(labelKey)}</h3></div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default Personal;